var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('breadcrumbs',{attrs:{"guia":"Movimentação de Vidas","titulo":"Movimentação de Vidas","descricao":"Faça a movimentação de vidas, consulte histórico e crie relatórios"}}),_c('v-layout',{staticClass:"main"},[_c('Vidas')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }